"use client";

import { Facebook, Instagram, Twitter, Youtube, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="grid grid-cols-2 gap-x-8 gap-y-3">
        {Array.from({
        length: 8
      }).map((_, i) => <div key={i} data-index={i} className="h-5 w-28 bg-secondary animate-pulse rounded-md" />)}
      </div>;
  }
  const items = menuItems.slice(0, 8);
  const padded = [...items, ...Array.from({
    length: Math.max(0, 8 - items.length)
  })];
  return <ul className="grid grid-cols-2 gap-x-8 gap-y-3">
      {padded.map((item, i) => <li data-index={i} key={i} className="flex items-baseline gap-2">
          <span className="font-mono text-xs tracking-widest text-primary" aria-hidden="true">
            {`§${String(i + 1).padStart(2, "0")}`}
          </span>
          {item ? <Link to={(item as {
        href?: string;
      }).href || "#"} className="group relative inline-block text-[15px] font-default font-medium text-foreground hover:text-primary transition-colors duration-200">
              <span className="relative">
                {(item as {
            label: string;
          }).label}
                <svg className="absolute -bottom-1 left-0 w-full h-1 opacity-0 group-hover:opacity-100 transition-opacity" viewBox="0 0 80 6" fill="none" preserveAspectRatio="none" aria-hidden="true">
                  <path d="M2 3 Q 15 0, 28 3 T 54 3 T 78 3" stroke="hsl(43 89% 52%)" strokeWidth="1.5" strokeLinecap="round" fill="none" />
                </svg>
              </span>
            </Link> : <span className="text-[15px] font-default font-medium text-foreground/30">—</span>}
        </li>)}
    </ul>;
}
const socials = [{
  name: "Twitter",
  href: "#",
  rotation: "-rotate-3"
}, {
  name: "Instagram",
  href: "#",
  rotation: "rotate-3"
}, {
  name: "Facebook",
  href: "#",
  rotation: "-rotate-2"
}, {
  name: "Youtube",
  href: "#",
  rotation: "rotate-2"
}];
function SocialIcon({
  name
}: {
  name: string;
}) {
  const cls = "w-5 h-5";
  if (name === "Twitter") return <Twitter className={cls} strokeWidth={2.5} />;
  if (name === "Instagram") return <Instagram className={cls} strokeWidth={2.5} />;
  if (name === "Facebook") return <Facebook className={cls} strokeWidth={2.5} />;
  return <Youtube className={cls} strokeWidth={2.5} />;
}
export default function SiteFooter() {
  return <section data-section-id="1128" id="site-footer" className="relative overflow-hidden bg-primary py-20 md:py-24">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03]" aria-hidden="true" style={{
      backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'><g fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M20 25 l4 -8 l4 8 l8 0 l-6 6 l2 8 l-8 -4 l-8 4 l2 -8 l-6 -6 z'/><path d='M120 30 l3 6 l6 0 l-5 4 l2 6 l-6 -4 l-6 4 l2 -6 l-5 -4 l6 0 z'/><path d='M70 60 l-4 8 l6 0 l-3 8 l8 -10 l-6 0 l5 -8 z'/><path d='M130 90 q 10 -8 18 0 q -4 6 -10 6 q -6 0 -8 -6 z M134 90 l4 4 M140 88 l2 6'/><path d='M30 110 q 8 -6 14 0 q -3 4 -7 4 q -4 0 -7 -4 z M34 110 l3 3'/><path d='M90 125 l3 -6 l3 6 l6 0 l-5 4 l2 6 l-6 -4 l-6 4 l2 -6 l-5 -4 z'/><path d='M55 30 l8 4 l-8 4 M60 28 l0 12'/><path d='M105 130 q -4 -8 4 -10 q 8 -2 6 6 q 0 4 -5 4 q -3 0 -5 0 z'/></g></svg>")`,
      backgroundRepeat: "repeat"
    }} />

      {}
      <div className="pointer-events-none absolute top-4 left-4 w-3 h-3" aria-hidden="true">
        <div className="absolute top-0 left-0 w-3 h-[3px] bg-accent" />
        <div className="absolute top-0 left-0 w-[3px] h-3 bg-accent" />
      </div>
      <div className="pointer-events-none absolute top-4 right-4 w-3 h-3" aria-hidden="true">
        <div className="absolute top-0 right-0 w-3 h-[3px] bg-accent" />
        <div className="absolute top-0 right-0 w-[3px] h-3 bg-accent" />
      </div>
      <div className="pointer-events-none absolute bottom-20 left-4 w-3 h-3" aria-hidden="true">
        <div className="absolute bottom-0 left-0 w-3 h-[3px] bg-accent" />
        <div className="absolute bottom-0 left-0 w-[3px] h-3 bg-accent" />
      </div>
      <div className="pointer-events-none absolute bottom-20 right-4 w-3 h-3" aria-hidden="true">
        <div className="absolute bottom-0 right-0 w-3 h-[3px] bg-accent" />
        <div className="absolute bottom-0 right-0 w-[3px] h-3 bg-accent" />
      </div>

      <div className="relative max-w-[1440px] mx-auto px-4 md:px-8">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {}
          <div className="md:col-span-5">
            <Link to="/HomePage" className="inline-block">
              <WvcLogo className="h-10 w-auto text-white" />
            </Link>
            <p className="mt-6 text-[17px] leading-snug font-default text-white/90">
              —Helping pets live healthier, happier lives.
            </p>

            <div className="mt-8 flex items-center gap-4">
              {socials.map((s, i) => <Link data-index={i} key={s.name} to={s.href} aria-label={s.name} className={`group relative inline-flex items-center justify-center w-11 h-11 rounded-lg border-[2.5px] border-white/10 bg-white text-primary ${s.rotation} hover:rotate-0 transition-transform duration-300`}>
                  <SocialIcon name={s.name} />
                </Link>)}
            </div>
          </div>

          {}
          <div className="md:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.18em] mb-5 text-accent-foreground">
              § NAVIGATION
            </p>
            <MenuProvider menu_id="46">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.18em] mb-4 text-accent-foreground">
              § RESOURCES
            </p>
            <Button asChild className="bg-chart-2 hover:bg-chart-2/90 text-primary border-none rounded-lg font-default font-semibold text-base px-6 py-6 h-auto transition-transform duration-150 hover:scale-105">
              <Link to="/StartHerePage">
                Download Tracker
                <ArrowRight className="ml-2 w-4 h-4" strokeWidth={3} />
              </Link>
            </Button>

            <div className="mt-10">
              <p className="font-mono text-xs uppercase tracking-[0.18em] leading-relaxed text-white/70">
                § FIT PET GUIDE
                <br />
                <span className="text-white">· VET-APPROVED ·</span>
              </p>
              <p className="mt-3 font-mono text-[11px] tracking-wider text-white/50">
                SUPPORTING HEALTHY
                <br />
                WEIGHT JOURNEYS
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 pt-6 border-t-2 flex flex-col md:flex-row md:items-center md:justify-between gap-3 border-white/10">
          <p className="font-mono text-xs uppercase tracking-[0.18em] text-white/60">
            © 2025 FIT PET GUIDE
          </p>
          <p className="font-mono text-xs uppercase tracking-[0.18em] text-white/60">
            MADE WITH <span aria-hidden="true"></span> CARE <span aria-hidden="true"></span> FOR PETS
          </p>
        </div>
      </div>
    </section>;
}